module.exports = __webpack_public_path__ + "fonts/pts.8952114.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pts.woff?1k5nh7
// module id = 1104
// module chunks = 0